export default __webpack_public_path__ + "static/media/ruler-1.46deb991.png";